import { createFileRoute, redirect } from '@tanstack/react-router';
import { getPendingInvites } from '@/lib/api/user-management/invitesApi';
import { inviteAutoAcceptIntent } from '@/lib/utils/invites/autoAcceptIntent';

export const Route = createFileRoute('/(app)/')({
  loader: async ({ context }) => {
    if (inviteAutoAcceptIntent.peek()) {
      throw redirect({ to: '/invites/auto-accept' });
    }

    const { organizationName } = context;
    if (!organizationName) {
      throw redirect({ to: '/' });
    }

    let hasPendingInvites = false;
    try {
      const { invites } = await getPendingInvites();
      hasPendingInvites = invites.length > 0;
    } catch {
      // Fall through to org redirect
    }

    if (hasPendingInvites) {
      throw redirect({ to: '/invites' });
    }

    throw redirect({
      to: '/org/$org',
      params: { org: organizationName },
    });
  },
});
